import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useCredentialRequirementConfiguration() {
  const configuration = useCbhFlag(CbhFeatureFlag.CREDENTIAL_REQUIREMENTS_CONFIGURATION, {
    defaultValue: [],
  });

  return new Set(configuration);
}
